/** Shared formatting for Invoice Logs (the page and each invoice's history). */

/** '24 Oct 2026, 02:15:09 pm' — the exact moment of the change. */
export const logTime = (iso: string) =>
  new Date(iso).toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true });

/** 'Saturday' */
export const logDay = (iso: string) => new Date(iso).toLocaleDateString('en-IN', { weekday: 'long' });

/** SUPER_ADMIN → 'Super Admin' */
export const prettyRole = (code: string) =>
  code.toLowerCase().split('_').map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');

export const ACTION_TONE: Record<string, string> = {
  Created: 'bg-accent/15 text-accent',
  Edited: 'bg-info/15 text-info',
  Issued: 'bg-success/15 text-success',
  'Payment recorded': 'bg-success/15 text-success',
  Cancelled: 'bg-danger/15 text-danger',
  'Attachment added': 'bg-violet-500/15 text-violet-600',
  'Attachment removed': 'bg-warning/15 text-warning',
};
